/*
    Generated file
    Do not alter.
    21-11-2021 21:43:10
 */
import axios from 'axios';

export default function ApiHandler(apiUrl) {
    let baseurl = "";
    if (process.env.NODE_ENV == "development")
        baseurl = 'http://localhost:8080/api/api/Sproc/';
    else
        baseurl = '/api/api/Sproc/';

    this.axios = axios;
    this.apiUrl = apiUrl || baseurl;
    this.updateHeaders();
}

ApiHandler.prototype.updateHeaders = function () {
    this.config = {
        headers: {
            "content-type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("session-id")
        },
        baseURL: this.apiUrl,
        withCredentials: true,
    };
    this.configBlob = {
        headers: {
            "content-type": "application/json",
            "Authorization": "Bearer " + sessionStorage.getItem("session-id")
        },
        baseURL: this.apiUrl,
        withCredentials: true,
        responseType: 'blob',
    };
}

    // pAntwoordPoll
    ApiHandler.prototype.pAntwoordPoll = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspAntwoordPoll' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pAntwoordSave
    ApiHandler.prototype.pAntwoordSave = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspAntwoordSave' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pAntwoordSaveWeb
    ApiHandler.prototype.pAntwoordSaveWeb = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspAntwoordSaveWeb' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pCleanAfgebrokenSessies
    ApiHandler.prototype.pCleanAfgebrokenSessies = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspCleanAfgebrokenSessies' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pClientGet
    ApiHandler.prototype.pClientGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspClientGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pClientSave
    ApiHandler.prototype.pClientSave = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspClientSave' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pControleerAuthCode
    ApiHandler.prototype.pControleerAuthCode = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspControleerAuthCode' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pLeeftijdCategorieenGet
    ApiHandler.prototype.pLeeftijdCategorieenGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspLeeftijdCategorieenGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pLocatiesGet
    ApiHandler.prototype.pLocatiesGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspLocatiesGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pMedewerkerFotoGet
    ApiHandler.prototype.pMedewerkerFotoGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspMedewerkerFotoGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pMedewerkerFotoSave
    ApiHandler.prototype.pMedewerkerFotoSave = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspMedewerkerFotoSave' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pMedewerkersGet
    ApiHandler.prototype.pMedewerkersGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspMedewerkersGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pOverzichtConsoles
    ApiHandler.prototype.pOverzichtConsoles = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspOverzichtConsoles' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pOverzichtTokens
    ApiHandler.prototype.pOverzichtTokens = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspOverzichtTokens' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pProvinciesGet
    ApiHandler.prototype.pProvinciesGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspProvinciesGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pRapportSessie
    ApiHandler.prototype.pRapportSessie = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspRapportSessie' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pRapportSessieExcel
    ApiHandler.prototype.pRapportSessieExcel = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspRapportSessieExcel' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pRapportTotaal
    ApiHandler.prototype.pRapportTotaal = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspRapportTotaal' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pRapportVraag
    ApiHandler.prototype.pRapportVraag = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspRapportVraag' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pRapportVraagExcel
    ApiHandler.prototype.pRapportVraagExcel = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspRapportVraagExcel' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pRechtenGet
    ApiHandler.prototype.pRechtenGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspRechtenGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pRegisterConsole
    ApiHandler.prototype.pRegisterConsole = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspRegisterConsole' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pRegisterToken
    ApiHandler.prototype.pRegisterToken = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspRegisterToken' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pResetConsole
    ApiHandler.prototype.pResetConsole = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspResetConsole' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pResetToken
    ApiHandler.prototype.pResetToken = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspResetToken' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pSessieBeeindig
    ApiHandler.prototype.pSessieBeeindig = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspSessieBeeindig' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pTokenCheck
    ApiHandler.prototype.pTokenCheck = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspTokenCheck' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pTokensGet
    ApiHandler.prototype.pTokensGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspTokensGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pVragensessieGet
    ApiHandler.prototype.pVragensessieGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspVragensessieGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pVragensessieGetStatus
    ApiHandler.prototype.pVragensessieGetStatus = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspVragensessieGetStatus' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // pVragensetsGet
    ApiHandler.prototype.pVragensetsGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('sspVragensetsGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // Login
    ApiHandler.prototype.Login = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('Login' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // Logout
    ApiHandler.prototype.Logout = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pUserLogout' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // RequestPasswordReset
    ApiHandler.prototype.RequestPasswordReset = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('RequestPasswordReset' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // PasswordReset
    ApiHandler.prototype.PasswordReset = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('PasswordReset' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // Authenticated
    ApiHandler.prototype.Authenticated = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pAuthenticated' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // ValidationRulesGet
    ApiHandler.prototype.ValidationRulesGet = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pValidationRulesGet' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // UserGetList
    ApiHandler.prototype.UserGetList = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pUserGetList' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // UserInitNew
    ApiHandler.prototype.UserInitNew = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pUserInitNew' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // UserGetDetails
    ApiHandler.prototype.UserGetDetails = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pUserGetDetails' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // UserSave
    ApiHandler.prototype.UserSave = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pUserSave' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // UserValidate
    ApiHandler.prototype.UserValidate = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('pUserValidate' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }

    // NewUserMail
    ApiHandler.prototype.NewUserMail = function(data, frmt) {
        return new Promise((resolve, reject) => {
            let config = null;
            if (frmt) { frmt = "?format=" + frmt; config = this.configBlob; } else { frmt = ""; config = this.config; }
            this.axios.post('NewUserMail' + frmt, data, config)
                .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject('Bad request ' + response.code.toString());
                }
            })
            .catch(() => {
                reject('Server error');
            });
        });
    }



    // Download
    ApiHandler.prototype.saveDownload = function(data, filename) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    }